import type { ReactElement } from 'react';
import { AddTextButton } from '@/features/design-editor';
import { AddImageButton, type UploadedDesignImage } from '@/features/design-image-upload';
import { ChangeProductLink } from './change-product-link';

interface ToolRailProps {
  readonly changeProductHref: string;
  readonly imageDisabledReason: string | null;
  readonly textDisabledReason: string | null;
  /** 비회원 키 — 있으면 이미지를 비회원 업로드 API 로 올린다. 회원은 null. */
  readonly guestKey: string | null;
  readonly onImageUploaded: (image: UploadedDesignImage) => void;
  readonly onAddText: () => void;
}

/**
 * 스테이지 도구 칸 — 상품 변경 · 이미지 업로드 · 텍스트를 얇은 선으로 나눈 흰 사각 칸으로 둔다.
 * 넓은 화면은 캔버스 왼쪽 세로 줄, 좁은 화면은 캔버스 아래 가로 세 칸이 된다.
 */
export const ToolRail = ({
  changeProductHref,
  imageDisabledReason,
  textDisabledReason,
  guestKey,
  onImageUploaded,
  onAddText,
}: ToolRailProps): ReactElement => (
  <nav
    aria-label="디자인 도구"
    className="flex shrink-0 divide-x divide-foreground/10 border-t border-foreground/10 bg-background lg:w-24 lg:flex-col lg:divide-x-0 lg:divide-y lg:border-t-0 lg:border-r"
  >
    <AddImageButton
      disabledReason={imageDisabledReason}
      guestKey={guestKey}
      onUploaded={onImageUploaded}
    />
    <AddTextButton disabledReason={textDisabledReason} onAdd={onAddText} />
    <ChangeProductLink href={changeProductHref} />
  </nav>
);
